import React from 'react'
import PRPIcon from "assets/PRP.png";
import BFLIcon from "assets/BFL.png";
import GrayQuest from "../../../../../../../assets/img/GrayQuest.png"
import jodo from "assets/img/jodo.png";
import edv from "assets/img/edv.png"
import upi from "assets/img/svg/upi.png";
import { ReactComponent as FullCourseIcon } from "assets/img/svg/GraduationCap.svg";
import { ReactComponent as OnlineIcon } from "assets/img/svg/Online.svg";
import JodoIcon from "assets/JODO.png";
import { ReactComponent as ChequeIcon } from "assets/img/svg/cheque.svg";
import { ReactComponent as StudentIcon } from "assets/img/svg/Student.svg";
import { defaultColorStyle } from '../../../collectPayment/selectPaymentMode/components/constant';

export const paymentModesConfig = [
    { id: 1, label: "Lumpsum", key: "lumpsum" },
    { id: 2, label: "Financing", key: "financing" }, 
    { id: 3, label: "eNACH", key: "eNACH" },
    { id: 4, label: "PDCs", key: "pdc" },
    { id: 5, label: "Seat Booking", key: "seatBooking" },
];

export const paymentModeTabsGrouping = {
    lumpsum: [
        { icon: <StudentIcon/>, text: "First year", key: "OP",chargesSubType: 'LUMPSUM_First_Year', chargesType: 'LUMPSUM' },
        { icon: <FullCourseIcon/>, text: "Full Course", key: "OP",chargesSubType: 'LUMPSUM_Full_Course',chargesType: 'LUMPSUM' },
    ],
    pdc: [
        { icon: <ChequeIcon />, text: "Cheque", key: "CHKL",paymentModeKey: 'CHKL' },
    ],
    financing: [
        {
            icon: <img src={BFLIcon} />,
            text: "Bajaj Finserv",
            key: "BFL",
            type: 'loan',
            loanVendor: "BFL",
            paymentModeKey: "BFL"
        },
        {
            icon: <img src={PRPIcon} />,
            text: "Propelled",
            key: "PRP",
            type:'loan',
            loanVendor:'Propelld Scheme',
            paymentModeKey: "PRP"
        },
        {
            icon: <img src={edv} />,
            text: "Eduvance",
            key: "EDV",
            type:'loan',
            loanVendor:'Eduvanz Scheme',
            paymentModeKey: "EDV"
        },
        {
            icon: <img src={GrayQuest} />,
            text: "Gray Quest",
            key: "GQC",
            type:'loan',
            loanVendor:'GrayQuest LOAN',
            paymentModeKey: "GQC",
            // isRecommended: true
        },
        {
            icon: <img src={jodo} />,
            text: "JODO EMI",
            key: "JEMI",
            type:'loan',
            loanVendor: "JODO EMI Scheme",
            paymentModeKey: "JEMI"
        },
    ],
    seatBooking: [
        {
            icon: <StudentIcon />,
            text: "Reg only",
            key: "OP",
            chargesSubType: 'REG', 
            chargesType: 'SEAT_BOOKING' 
        },
        {
            icon: <StudentIcon />,
            text: "Reg + Adm",
            key: "OP",
            chargesSubType: 'REG_ADM', 
            chargesType: 'SEAT_BOOKING'
        },
         {
            icon: <StudentIcon />,
            text: "Reg + Sec",
            key: "OP",
            chargesSubType: 'REG_SEC', 
            chargesType: 'SEAT_BOOKING',
            isSdCourseValidation: true
        },
         {
            icon: <StudentIcon />,
            text: "Reg + Adm + Sec",
            key: "OP",
            chargesSubType: 'REG_ADM_SEC', 
            chargesType: 'SEAT_BOOKING',
            isSdCourseValidation: true
        },
        {
            icon: <StudentIcon />,
            text: "Reg + Adm + 1st Inst",
            key: "OP",
            chargesSubType: 'UPTO_1st', 
            chargesType: 'SEAT_BOOKING'
        }
    ],
    eNACH: [
        {
            icon: <img src={upi} />,
            text: "eNACH",
            key: "JODO",
            paymentModeKey: "JODO"
        },
    ]
}

export const getUpdatedPaymentTabIndex = (item) => {
  if (!item) return 0;

  let tabKey = null;

  if (item.loanSchemeMasterId) {
    tabKey = 'financing';
  } else {

    for (const [key, tabItems] of Object.entries(paymentModeTabsGrouping)) {
      const match = tabItems.some((tabItem) => {
        if (tabItem.chargesType && tabItem.chargesType === item.chargesType) return true;
        if (tabItem.paymentModeKey && tabItem.paymentModeKey === item?.paymentMode?.paymentModeKey) return true;

        return false;
      });

      if (match) {
        tabKey = key;
        break;
      }
    }
  }

  const index = paymentModesConfig.findIndex((config) => config.key == tabKey);

  return index==-1 ? 0: index; 
};

export const paymentTypeDisplayText={
    LUMPSUM: 'Lumpsum',
    SEAT_BOOKING: 'Seat Booking'
}
